var category = ['1/1', '1/2', '1/3', '1/4', '1/5', '1/6', '1/7', '1/8', '1/9', '1/10', '1/11', '1/12', '1/13', 
  '1/14', '1/15', '1/16', '1/17', '1/18']
var lineData = [18092, 20728, 24045, 28348, 32808, 36097, 39867, 44715, 48444, 50415, 56061, 62677, 59521, 67560, 18092,
  20728, 24045, 28348, 32808, 36097, 39867, 44715, 48444, 50415, 36097, 39867, 44715, 48444, 50415, 50061, 32808]

var barData = [4600, 5000, 5500, 6500, 7500, 8500, 9900, 12500, 14000, 21500, 23200, 24450, 25250, 33300, 4600, 5000, 
  5500, 6500, 7500, 8500, 9900, 22500, 14000, 21500, 8500, 9900, 12500, 14000, 21500, 23200, 24450]

var rateData = []

for (var i = 0; i < 33; i++) {
  var rate = barData[i] / lineData[i];
  rateData[i] = rate.toFixed(2);
}


// option
export default {
  title: {
    text: '每日交易额/订单数',
    x: 14,
    y: 10,
    textStyle: {
      color: '#34DEE5',
      fontSize: 21,
      fontWeight: 'bold',
    },

  },

  tooltip: {
    trigger: 'axis',
    // backgroundColor: 'rgba(255,255,255,0.1)',
    // axisPointer: {
    //   type: 'shadow',
    //   label: {
    //     show: true,
    //     backgroundColor: '#7B7DDC'
    //   }
    // }
  },

  legend: {
    data: ['交易额', '订单数'],
    textStyle: {
      color: '#B4B4B4'
    },
    top: 10
  },

  grid: {
    width: '82%',
    height: '70%',
  },

  xAxis: {
    data: category,
    axisLine: {
      lineStyle: {
        color: 'rgba(103, 224, 227, 1)'
      }
    },
    axisTick: {
      show: false,
    },
  },

  yAxis: [{

    splitLine: { show: false },
    axisLine: {
      lineStyle: {
        color: '#FFF',
      }
    },

    axisLabel: {
      formatter: '{value} ',
    }
  },
  {

    splitLine: { show: false },
    axisLine: {
      lineStyle: {
        color: '#FFF',
      }
    },
    axisLabel: {
      formatter: '{value} ',
    }
  }],

  series: [
    {
      name: '交易额',
      type: 'bar',
      barWidth: 10,
      itemStyle: {
        normal: {
          borderColor: 'rgba(103, 224, 227, 1)'
        }
      },
      data: barData
    },
    {
      name: '订单数',
      type: 'line',
      smooth: true,
      showAllSymbol: true,
      symbol: 'none',
      symbolSize: 2,
      yAxisIndex: 1,
      itemStyle: {
        color: 'rgba(251, 114, 147, 1)'
      },
      lineStyle: {
        color: 'rgba(251, 114, 147, 1)',
        width: 2,
        type: 'dotted'
      },
      areaStyle: {
        normal: {
          shadowColor: 'rgba(108,80,243, 0.9)',
          shadowBlur: 20
        }
      },
      emphasis: {
        lineStyle: {
          color: 'rgba(251, 114, 147, 1)',
          width: 2,
          type: 'dotted'
        }
      },
      data: rateData
    }
  ]
}